export default "<div class=\"in-block-spinner-container\">\n  <p-progressSpinner strokeWidth=\"5\"></p-progressSpinner>\n</div>\n"